// extracted by mini-css-extract-plugin
export default {"wrap":"oYtpqiayW4NA4Ft5IuxH","details":"lVyRmsxFm6BE0_90TUi8"};